import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import TextField from '../../../../../../components/FormLegacy/FormFieldsV2/TextField'
import SelectField from '../../../../../../components/FormLegacy/FormFieldsV2/SelectField'
import Icon from '../../../../../../components/Icons'
import {
  getMessageTypeFilterOptions,
  getDateStartTriggers,
  getContinueStartTriggers,
} from '../../../helpers'

const ChecklistTemplateNavbar = ({
  typeFilter,
  continueTrigger,
  dateTrigger,
  withinDays,
  editModeList,
  editData,
  errors,
  handleEditValue,
  setWithinDays,
  setContinueTrigger,
  validateField,
  setEditModeList,
  setTypeFilter,
  setErrors,
  isSubmitting,
  isDisabled,
}) => {
  const { t } = useTranslation(['checklists-legacy'])
  const messageTypeFilterOptions = getMessageTypeFilterOptions(t)
  const dateStartTriggers = getDateStartTriggers(t)
  const continueStartTriggers = getContinueStartTriggers(t)

  return (
    <div className="template-navbar">
      <div className="left-side">
        {editModeList.includes('name') ? (
          <div className="big-columns">
            <TextField
              autoFocus
              maxLength={50}
              name={'name'}
              placeholder={t('checklists-legacy:templateForm.navbar.namePlaceholder')}
              value={editData.name}
              onChange={(e) => handleEditValue('name', e.target.value)}
              autoComplete="new-password"
              disabled={isSubmitting}
              isError={errors.includes('name')}
              errorLabel={
                errors.includes('name') ? t('checklists-legacy:templateForm.requiredMax50') : ''
              }
              onBlur={() => handleEditValue('name', editData.name.trim())}
            />
            <span className="cross-icon" onClick={() => handleEditValue('name', '')}>
              <Icon icon="cross" viewBox="0 0 23 20" />
            </span>
          </div>
        ) : (
          <React.Fragment>
            {editData.name ? (
              <div className="element-value">{editData.name}</div>
            ) : (
              <div className="element-value placeholder">
                {t('checklists-legacy:templateForm.navbar.namePlaceholder')}
              </div>
            )}
            {!isDisabled && (
              <span
                className="editPen-icon"
                onClick={() => setEditModeList([...editModeList, 'name'])}
              >
                <Icon icon="editPen" viewBox="2 2 20 20" />
              </span>
            )}
          </React.Fragment>
        )}
      </div>
      <div className="right-side">
        <div className="text-bold">{t('checklists-legacy:templateForm.navbar.selectType')}</div>
        <SelectField
          name={'typeFilter'}
          value={typeFilter}
          placeholder={t('checklists-legacy:templateForm.navbar.typePlaceholder')}
          options={messageTypeFilterOptions.map((opt) => ({ ...opt, label: opt.text })).splice(1)}
          onChange={(e) => setTypeFilter(e.target.value)}
          disabled={isSubmitting || isDisabled}
          isError={errors.includes('typeFilter')}
        />
        <div className="text-bold">{t('checklists-legacy:templateForm.navbar.dueDate')}</div>
        <TextField
          name="dueDateDays"
          id="dueDateDays"
          placeholder={t('checklists-legacy:templateForm.navbar.dueDateDaysPlaceholder')}
          type="number"
          onChange={(e) => {
            setWithinDays(e.target.value)
            validateField(e.target.value, 'dueDateDays', 1, 30)
          }}
          value={withinDays || ''}
          disabled={isSubmitting || isDisabled}
          onBlur={(e) => validateField(e.target.value, 'dueDateDays', 1, 30)}
          className={`${errors.includes('dueDateDays') && 'is-danger'}`}
          isError={errors.includes('dueDateDays')}
          errorLabel={
            errors.includes('dueDateDays')
              ? t('checklists-legacy:templateForm.navbar.requiredMax30Days')
              : ''
          }
        />
        <div className="text-bold">{t('checklists-legacy:templateForm.navbar.days')}</div>
        <SelectField
          name={'dueDateCondition'}
          value={continueTrigger}
          placeholder={t('checklists-legacy:templateForm.navbar.selectTriggerPlaceholder')}
          options={continueStartTriggers}
          onChange={(e) => {
            setContinueTrigger(e.target.value)
            setErrors(errors.filter((err) => err !== 'dueDateCondition'))
          }}
          disabled={isSubmitting || isDisabled || typeFilter === 'move-out'}
          isError={errors.includes('dueDateCondition')}
        />
        <SelectField
          name={'dueDateTrigger'}
          value={dateTrigger}
          placeholder={t('checklists-legacy:templateForm.navbar.selectDatePlaceholder')}
          options={dateStartTriggers}
          disabled
        />
      </div>
    </div>
  )
}

ChecklistTemplateNavbar.propTypes = {
  typeFilter: PropTypes.string,
  continueTrigger: PropTypes.string,
  dateTrigger: PropTypes.string,
  withinDays: PropTypes.number,
  editModeList: PropTypes.array,
  editData: PropTypes.object,
  errors: PropTypes.array,
  handleEditValue: PropTypes.func,
  setWithinDays: PropTypes.func,
  setContinueTrigger: PropTypes.func,
  validateField: PropTypes.func,
  setEditModeList: PropTypes.func,
  setTypeFilter: PropTypes.func,
  setErrors: PropTypes.func,
  isSubmitting: PropTypes.bool,
  isDisabled: PropTypes.bool,
}

export default ChecklistTemplateNavbar
